<template>
  <div class="manage-shops-page">
    <PageHeader title="Gestion des magasins"/>
    <PageContainer size="small">
      <Card v-loading="loading">
        <div class="profile-jumbo__header">
        <span class="profile-name" data-test="jumbo__display-name">
          <el-input
            placeholder="Filter par ID, email ou nom magasin"
            v-model="searchQuery">
          </el-input>
        </span>
        </div>
        <div style="margin-top: 20px"></div>
        <div>
          <el-checkbox-group v-model="typeFilter" v-if="canFilterShops">
            <el-checkbox label="MB">Boulangeries</el-checkbox>
            <el-checkbox label="FL">Fruits et légumes</el-checkbox>
          </el-checkbox-group>
        </div>
        <div style="margin-top: 30px;" v-if="canAddShops">
          <el-button
            type="primary"
            icon="el-icon-plus"
            @click="show.createShopDialog = true"
          >Créer un magasin pour mon-compte
          </el-button>
          <CreateAMCShopDialog
            v-if="show.createShopDialog"
            :visible="show.createShopDialog"
            @created="shops.push($event)"
            @close="show.createShopDialog = false;"
          />
        </div>
      </Card>
      <div style="margin-top: 40px;"></div>
      <Table
        v-loading="loading"
        :columns="columns"
        :data="filteredData"
        :paginable="true">
      </Table>
    </PageContainer>
  </div>
</template>
<script>
import services from 'services';
import PageHeader from '@/components/PageHeader/PageHeader.vue';
import PageContainer from '@/components/PageContainer/PageContainer.vue';
import Table from '@/components/Table/Table.vue';
import CreateAMCShopDialog from '@/components/CreateAMCShopDialog/Index.vue';
import Card from '@/components/Card/Card.vue';

export default {
  components: {
    PageHeader,
    PageContainer,
    CreateAMCShopDialog,
    Table,
    Card,
  },
  async mounted() {
    this.loading = true;
    await this.fetchData();
    this.loading = false;
  },
  data() {
    return {
      loading: false,
      shops: [],
      searchQuery: '',
      typeFilter: ['MB', 'FL'],
      show: { createShopDialog: false },
      columns: {
        id: { key: 'id', label: 'ID' },
        name: { key: 'name', label: 'Nom' },
        email: { key: 'email', label: 'email' },
        type: {
          key: 'type',
          label: 'Type',
          type: 'tag',
          tagConfig: {
            size: 'mini',
            content(_, row) {
              return ['MB', 'CDM-PRT'].includes(row.type) ? 'Boulangerie' : 'Fruits & Légumes';
            },
            type(_, row) { return row.type === 'MB' ? 'success' : 'primary'; },
          },
        },
        button: {
          key: 'buttons',
          type: 'button',
          buttonConfig: {
            buttonText: 'Ouvrir',
            type: 'primary',
            size: 'mini',
            onClick: (_, row, router) => {
              console.log('push', row.id, router.push);
              router.push({ name: 'ShopPage', params: { shopId: row.id }, query: { shopType: row.type } });
            },
          },
        },
      },
      displayAddUserDialog: false,
    };
  },
  methods: {
    async fetchData() {
      const source = process.env.VUE_APP_ORGANIZATION === 'CDM_PRT' ? 'AMC' : 'AD';
      this.shops = await services.shopService.listAllShops(source);
    },
    showAddUserDialog() {
      this.displayAddUserDialog = true;
    },
    hideAddUserDialog() {
      this.displayAddUserDialog = false;
    },
    handleUserAdded(user) {
      this.users.push(user);
    },
  },
  computed: {
    canAddShops() {
      return this.isPortugalShop;
    },
    canFilterShops() {
      return !this.isPortugalShop;
    },
    isPortugalShop() {
      return process.env.VUE_APP_ORGANIZATION === 'CDM_PRT';
    },
    filteredByType() {
      if (this.isPortugalShop) {
        return this.shops;
      }
      return this.shops.filter((shop) => this.typeFilter.includes(shop.type));
    },
    filteredData() {
      if (this.searchQuery.length === 0) {
        return this.filteredByType;
      }
      const query = this.searchQuery.toLowerCase();

      return this.filteredByType.filter((shop) => {
        const shopName = (shop.name || '').toLowerCase();
        const shopId = (shop.id || '').toLowerCase();
        const shopEmail = (shop.email || '').toLowerCase();

        return (shopName.includes(query)
          || shopId.includes(query)
          || shopEmail.includes(query));
      });
    },
  },
};
</script>
<style lang="stylus" scoped>
.manage-shops-page {
  width: 100%;
}
</style>
